export default __webpack_public_path__ + "static/media/56_desktop.fcc4aac1.jpg";